<template>
  <div ref="cell" class="grid-view__cell grid-field-many-to-many__cell">
    <div class="grid-field-many-to-many__list">
      <!-- Origem Flow: só o avatar (foto do Google ou iniciais), nome no
           tooltip — como a coluna de responsável do ClickUp. -->
      <div
        v-for="item in value"
        :key="item.id"
        v-tooltip="getCollaboratorName(item, $store)"
        class="field-multiple-collaborators__item"
      >
        <template v-if="item.id && item.name">
          <img
            v-if="item.avatar_url"
            class="field-multiple-collaborators__photo field-multiple-collaborators__photo--solo"
            :src="item.avatar_url"
            :alt="getCollaboratorName(item, $store)"
          />
          <div
            v-else
            class="field-multiple-collaborators__initials field-multiple-collaborators__initials--solo"
          >
            {{ getCollaboratorNameInitials(item, $store) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import collaboratorName from '@baserow/modules/database/mixins/collaboratorName'

export default {
  name: 'FunctionalGridViewFieldMultipleCollaborators',
  mixins: [collaboratorName],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
